export default {
  eula: 'Contratto di licenza dell\'utente finale',
  serviceTerms: 'Termini di servizio',
};
